
























































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { FileHelper as _file } from '@/helper/file.helper';
import { VAction } from '@/models/pagedlistmodel';
import { vehicleInventoryService } from '@/shared';
import {  LocationJsonVehicleScan } from '@/models/inventory/vehicle.inventory';
import { IDialogOption } from '@/models/dialog';
import * as VueGoogleMap from 'vue2-google-maps';
import { mask } from 'vue-the-mask';

Vue.use(VueGoogleMap, {
  load: {
    key: 'AIzaSyCKmRtPEsEE3mfqg09JZ_ueBhL8SqdUsbQ',
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },
});

@Component({
  props: ['methodName', 'progress'],
  computed: {
    pages() {
      return this.pagedDeals.totalPages;
    },
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
  directives: {
    mask,
  },
})

export default class VehicleScansPage extends Base {
  public vehicleScansItems: any[] = [];
  public childGridItems: any[] = [];
  public actions: VAction[] = [];
  public childGridActions: VAction[] = [];
  public loading: boolean = false;
  public childGridLoading: boolean = false;
  public pagination = new PaginationModel('fileName', true);
  public homeAttachmentLoader: boolean = false;
  public isDateInInventoryOnly: boolean = true;
  public isDownloadExcel: boolean = false;
  public isDownloadReport: boolean = false;
  public requestProgress: boolean = false;
  public downloadReportLoader: boolean = false;
  public numberOfDays: string = "";
  public activeText: string = '';
  public childGridVinNumber: string = "";
  public isOpenMapInfoWindow: boolean = true;
  public openMap: IDialogOption = {
    width: '100%',
    model: false,
  };

  public childGridPopup: IDialogOption = {
    width: 700,
    title: 'Vehicle History',
    model: false,
    loading: false,
    // onClose: (): void => {
    // },
  };

  public selectedLocation: LocationJsonVehicleScan = {
    createdAt: null,
    createdBy: '',
    createdByEmail: '',
    id: 0,
    latitude: '',
    longitude: '',
    rfidTag:''
  };

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'vehicleScans');
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.getVehicleScansList();
    this.setActions();
    this.setChildGridActions();
  }

  public headers: VHeaders[] = [
    {
      text: "Stock",
      align: 'left',
      value: 'stockNumber',
      sortable: true,
    },
    {
      text: "VIN",
      align: 'left',
      value: 'vin',
      sortable: true,
    },
    {
      text: "Make",
      align: 'left',
      value: 'make',
      sortable: true,
    },
    {
      text: "Model",
      align: 'left',
      value: 'model',
      sortable: true,
    },
    {
      text: "Color",
      align: 'left',
      value: 'color',
      sortable: true,
    },
    {
      text: "Odometer",
      align: 'left',
      value: 'odometer',
      sortable: true,
    },
    {
      text: "Date In Inventory",
      align: 'left',
      // value: 'dateInInventory',
      // //fieldType: 'date',
      // sortable: false,
      value: 'inventoryDate',
      sortable: true,
      fieldType: 'template',
      template: (item) => {
        var date = item.inventoryDate ? this.$moment(item.inventoryDate).utcOffset(0, false).format('MMM DD, YYYY') : 'N/A';
        return `<span> ${date}</span>`;
      },
    },
    {
      text: "Last RFID Scan",
      align: 'left',
      //fieldType: 'date',
      // value: 'lastRfidScan',
      // sortable: false,
      value: 'updatedAt',
      sortable: true,
      fieldType: 'template',
      template: (item) => {
        var date = item.updatedAt ? this.$moment(item.updatedAt).utcOffset(0, false).format('MMM DD, YYYY HH:MM:SS') : 'N/A';
        return `<span> ${date}</span>`;
      },
    },
    {
      text: this.$parent.$t('dealAttachment.gridHeaders.actions') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];

  public childGridHeaders: VHeaders[] = [
  {
      text: "Rfid Tag",
      align: 'left',
      value: 'rfidTag',
      sortable: false,
    },
    {
      text: "Created At",
      align: 'left',
      value: 'createdAt',
      sortable: false,
      fieldType: 'template',
      template: (item) => {
        var date = this.$moment(item.createdAt).utcOffset(0, false).format('MM/DD/YYYY');
        return `<span> ${date}</span>`;
      },
    },
    {
      text: this.$parent.$t('dealAttachment.gridHeaders.actions') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fa fa-info',
        title: 'Scan History',
        visible: (model) => {
          if (model.locationJson.length > 0) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          this.childGridPopup.loading = true;
          this.childGridPopup.model = true;
          this.childGridVinNumber = model.vin;
          this.childGridItems = model.locationJson;
          this.childGridPopup.loading = false;
        },
      },
    ];
  }

  public setChildGridActions() {
    this.childGridActions = [
      {
        type: 'button',
        icon: 'fas fa-map-marker',
        title: 'Locations',
        action: (model: any) => {
          this.openMapDialog(model);
        },
      },
    ];
  }

  public search(): void {
    this.pagination.page = 1;
    this.getVehicleScansList();
  }


  public async getVehicleScansList(): Promise<void> {
    try {
      this.loading = true;
      const response = await vehicleInventoryService.getVehicleScans(
        this.isDateInInventoryOnly,Number(this.numberOfDays),this.isDownloadExcel,this.isDownloadReport
      );
      this.vehicleScansItems = response.vehicleScans;
      this.pagination.totalItems = response.totalRecords;
      if(response.fileUri && this.isDownloadReport){
        window.open(response.fileUri, '_blank');
      }
    } finally {
      this.loading = false;
      this.isDownloadReport = false;
    }
  }

  public updatePaging(paging: PaginationModel): void {
    this.pagination = paging;
  }
  public toggleDateInInventory() {
    this.pagination.page = 1;
    this.getVehicleScansList();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'downLoadPDF') {
      this.isDownloadReport = true;
      this.isDownloadExcel = false;
      this.getVehicleScansList();
    }
    if (methodName === 'downLoadExcel') {
      this.isDownloadReport = true;
      this.isDownloadExcel = true;
      this.getVehicleScansList();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: "DownLoad PDF",
      disabled: false,
      visible: true,
      class: 'btn primary',
      label: "DownLoad PDF",
      click: 'downLoadPDF',
      icon: 'fas fa-download',
    });
    buttons.push({
      id: '1',
      type: 'button',
      title: "DownLoad EXCEL",
      disabled: false,
      visible: true,
      class: 'btn primary',
      label: "DownLoad EXCEL",
      click: 'downLoadExcel',
      icon: 'fas fa-download',
      requestProgress: this.loading,
      loading: this.loading
    });
    this.$emit('updateToolBar', buttons);
  }

  public openMapDialog(locationJson: any): void {
    this.openMap.model = true;
    this.selectedLocation = locationJson;
    this.activeText = `${this.selectedLocation.rfidTag} ${this.$moment(this.selectedLocation.createdAt).format('LLL')}`;
    this.isOpenMapInfoWindow = true;
  }

  public getVendorInvoices(items) {
    return items.locationJson;
  }

}
